import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
//import { Link, Redirect } from "react-router-dom";
import { Link, Redirect, useHistory } from "react-router-dom";
import { setAlert } from "../../actions/alert";
//import { register } from "../../actions/auth";
import { register, welcome_mail } from "../../actions/auth";
import PropTypes from "prop-types";
import Alert from '../../components/alert/Alert';
import { sendEmailFunc } from "../../actions/sendEmail";
import Input from '../../components/input/input';
import {SVGWidgetLogo,FormIcon} from '../../components/SVG'
import document from "ejs/ejs";
import { Country } from "country-state-city";
import {Helmet} from "react-helmet";

const Register = ({ setAlert, register, sendEmailFunc, isAuthenticated }) => {
  
  const history = useHistory()

  useEffect(() => {
    document.title = 'Register';
  }, []);

  const countries = Country.getAllCountries();

  const [formData , setFormData] = useState({
    user_name: "",
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    password2: "",
    checked: false,
    type: "",
    location:""
  });

  const { user_name, email, first_name, last_name, password, password2 , checked, type, location } =
    formData;

  const onChange = (e) => {
    if((e.target.name === 'first_name' || e.target.name === 'last_name' || e.target.name === 'user_name') && e.target.value.length > 15){
      return;
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const setChecked = () => {
    formData['checked'] = !formData['checked'];
    setFormData(formData);
  }


  const onSubmit = async (e) => {
    e.preventDefault();
    //if (password !== password2) {
    //  setAlert("Passwords do not match", "danger", 3000);
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const emailRegex = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
    const nameRegex = /\d/
    // console.log(email.split('@')[1].split('.')[0]);
    if(type==='' && checked === true){
      setAlert("User type is required", "danger", 3000);
      
    }else if(formData['checked'] === false){
      setAlert("Please accept the privacy policy", "danger", 3000);
    }else if (nameRegex.test(first_name) || nameRegex.test(last_name)) {
      setAlert("Please enter a valid name without numbers", "danger", 3000);
    }
    //else if(!['gmail', 'hotmail', 'yahoo', 'outlook'].includes(email.split('@')[1].split('.')[0])){
      //setAlert("Please use working email.", "danger", 3000);
    //}
    else if(!passwordRegex.test(password)){
      setAlert("Password must contain at least one lowercase letter, one uppercase letter, one digit, one special character (@, $, !, %, *, ?, &), and be at least 8 characters long.", "danger", 3000);
    }
    else if (password !== password2) {
      setAlert("Passwords do not match", "danger", 3000);
    } 
    else{
      register({ 
        user_name,
        email,
        first_name,
        last_name,
        password,
        type,
        history,
        location
      }).then((res)=>{

       /*
       debugger;
       var emailType = "new";
       var emailAddress = email;
       sendEmailFunc(
         emailAddress,{
         emailType
       });
       */

        if (res.data) {
          if(type === 'Freelancer'){
            history.push('/expert-email-verify');
          }else{
            history.push('/completeprofile');
          }
        }

      }).catch((err)=>{
        //console.log(err) //
        //yahan error handle karo
      })
    }

  };

  /*
  if (isAuthenticated) {
    return <Redirect to="/completeprofile" />;
  }
  */

function scrollToTop() {
    window.scrollTo(0, 0);
} 
 
  
  return (
    <>
    <Helmet>
      <title>Register</title>
    </Helmet>
    <section className="box-under-container page-registration page-auth">
      <div className="container">
        <section className="box-shadow m-auto">
          
          { <div className="text-center logo">
            <Link to="/">
              <SVGWidgetLogo/>
            </Link>                
          </div>}

          <h3 className="heading">Join us</h3>
            <p className="description">Make the most of your professional life</p>
              
         
            <div class="select-user-type">
              <div class="radio-container">
                <div class="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="type" id="inlineRadio1" value="Client" onChange={(e) => onChange(e)}/>
                  <label className="form-check-label" for="inlineRadio1">Looking for services (Cyber Client)</label>
                </div>
                <div class="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="type" id="inlineRadio2" value="Freelancer" onChange={(e) => onChange(e)}/>
                  <label className="form-check-label" for="inlineRadio2">Offer my services (Cyber Pro)</label>
                </div>
              </div>
            </div>
          <Alert />


          <form onSubmit={(e) => onSubmit(e)}>

            <Input 
              parentclass={`user`}
              labelfor={`userName`}
              id={`user1`}
              className={'error'}
              // label={`Username`}
              group={true}
              name={`user_name`}
              placeholder={`Username`}
              iconType={'user'}
              maxLength={20}
              required={true}
              type={'text'}
              value={user_name}
              handlerOnChange={(e) => onChange(e)}
              >
                {/* <span className="error-text">Error</span> */}
              </Input>

              <Input 
                labelfor={`FirstName`}
                id={`FirstName`}
                className={'error'}
                // label={`Username`}
                group={true}
                name={`first_name`}
                placeholder={`First Name`}
                iconType={'names'}
                required={true}
                type={'text'}
                value={first_name}
                handlerOnChange={(e) => onChange(e)}
              >
                {/* <span className="error-text">Error</span> */}
              </Input>

              <Input 
                labelfor={`LastName`}
                id={`LastName`}
                className={'error'}
                // label={`Username`}
                group={true}
                name={`last_name`}
                placeholder={`Last Name`}
                iconType={'user'}
                //icon={<FormIcon icon={'names'} />}
                required={true}
                type={'text'}
                value={last_name}
                handlerOnChange={(e) => onChange(e)}
              >
                {/* <span className="error-text">Error</span> */}
              </Input>
              
              <Input 
                labelfor={`Email`}
                id={`Email`}
                className={'error'}
                // label={`Username`}
                group={true}
                name={`email`}
                placeholder={`Email`}
                iconType={'email'}
                //icon={<FormIcon icon={'email'} />}
                required={true}
                type={'email'}
                value={email}
                handlerOnChange={(e) => onChange(e)}
              >
                {/* <span className="error-text">Error</span> */}
              </Input>


              <Input 
                labelfor={`password`}
                id={`password`}
                className={'error'}
                group={true}
                name={`password`}
                placeholder={`Password (8 or more characters)`}
                iconType={'password'}
                //icon={<FormIcon icon={'password'} />}
                required={true}
                type={'password'}
                handlerOnChange={(e) => onChange(e)}
                minLength={8}
                value={password}
                >
                {/* <span className="error-text">Error</span> */}
              </Input>

              <Input 
                labelfor={`ConfirmPassword`}
                id={`ConfirmPassword`}
                className={'error'}
                // label={`Username`}
                group={true}
                name={`password2`}
                placeholder={`Confirm Password`}
                iconType={'confirmpassword'}
                //icon={<FormIcon icon={'password'} />}
                required={true}
                type={'password'}
                handlerOnChange={(e) => onChange(e)}
                minLength={8}
                value={password2}
                >
                {/* <span className="error-text">Error</span> */}
              </Input>
              
              <div className="form-group">
                <label className="form-label mb-1">
                  Select Your Location <span className="required-field">*</span>
                </label>
                
                
                  <select
                    className="form-control"
                    name="location"
                    value={formData.location}
                    required={true}
                    onChange={(e) => onChange(e)}
                  >
                    <option>Please Select</option>
                    {countries.map((item) => (
                      <option
                        value={item.name}
                        data-isoCode={item.isoCode}
                      >
                        {item.name}
                      </option>
                    ))}
                  </select>
              </div>
                

            <div className="row justify-content-between">
              <div className="col-12 agreement-checkbox">              
                <div className="custom-control custom-checkbox mb-3">
                    <input type="checkbox" className="custom-control-input" id="customCheck1" onChange={() => setChecked()}/>
                    <label className="custom-control-label" htmlFor="customCheck1">You agree to CyberToCyber <Link to="/privacyPolicy" onClick={scrollToTop}>Privacy Policy</Link>.</label>
                </div>
              </div>
            </div>
            
            
            <button
              className="btn btn-default btn-block"
              type="submit"
            >Agree &amp; Join
            </button>
          
            <div className="py-3 login-here d-flex justify-content-between">              
              {/*<span className="text"><Link to="/registeradmin">Admin Register</Link></span>*/}
              <span className="text">Already have an account?  <Link to="/login"  onClick={scrollToTop} >Login here</Link></span>
            </div>
          </form>

        </section>
        </div>
    </section>    
    </>
  );
};

Register.propTypes = {
  setAlert: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProp = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProp, { setAlert, register, sendEmailFunc })(Register);
